import { Helpers } from '../../helpers';
import { IConstraintMinMaxRigsPerArea } from '../../interfaces/iconstraint-min-max-rigs-per-area';
import { AreaType } from '../area-type';
import { ConstraintMinMaxRigsPerAreaDetail } from '../constraint-min-max-rigs-per-area-detail';
import { Scenario } from '../scenario';

export class ConstraintMinMaxRigsPerAreaBase {
  ConstraintMinMaxRigsPerAreaId: number;
  ScenarioId: number;
  AreaTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintMinMaxRigsPerAreaDetails_ConstraintMinMaxRigsPerArea?: Array<ConstraintMinMaxRigsPerAreaDetail> | null;
  AreaType?: AreaType;
  Scenario?: Scenario;

  constructor(item?: IConstraintMinMaxRigsPerArea) {
    if (item) {

      this.ConstraintMinMaxRigsPerAreaId = item.ConstraintMinMaxRigsPerAreaId;
      this.ScenarioId = item.ScenarioId;
      this.AreaTypeId = item.AreaTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintMinMaxRigsPerAreaDetails_ConstraintMinMaxRigsPerArea = Helpers.createClassArray(ConstraintMinMaxRigsPerAreaDetail, item.ConstraintMinMaxRigsPerAreaDetails_ConstraintMinMaxRigsPerArea);
      this.AreaType = new AreaType(item.AreaType);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}